import { merge } from 'lodash';
import AxiosInstance from './axiosSetting';
import qs from 'qs';

const request = _options => {
  // 默认GET方法
  const method = (_options.method || 'GET').toUpperCase();
  const options = merge({
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
    ..._options,
  });
  return (params, config) => {
    if (params) {
      const key = ['PUT', 'POST', 'PATCH'].includes(method) ? 'data' : 'params';
      options[key] = params;
    }

    if (config) Object.assign(options, config);
    return AxiosInstance(options);
  };
};

/**
 * 封装get请求
 * @param { String } url 请求路径
 * @param { Object } 请求参数
 *  params GET请求参数
 */
const get = (url, params, _options) => {
  // let responseType = 'arraybuffer';
  return request({ ..._options, params, url })();
};

/**
 * 封装post请求
 * @param { Object } 请求参数
 *  data POST请求请求参数，对象形式
 */
const post = (url, data, _options) => {
  let method = 'POST';
  return request({ ..._options, data, url, method })();
};

export { get, post };
export default request;
